// @owners { team: patient-fulfillment }
import { createSelector } from 'reselect';
import { getSavedOnboardingInsurance } from './getSavedOnboardingInsurance';
import { getIsCurrentUserCashPayOnly } from '~shared/features/users/selectors/getUserCashPayOnly';

export const PHOTO = 'PHOTO';
export const MANUAL = 'MANUAL';
export const NONE = 'NONE';

export type InsuranceSourceType = typeof PHOTO | typeof MANUAL | typeof NONE;

export const getCurrentInsuranceType = createSelector(
  [getSavedOnboardingInsurance, getIsCurrentUserCashPayOnly],
  (insurance, isCashPayOnly): InsuranceSourceType | undefined => {
    if (insurance) {
      return insurance.image_url ? PHOTO : MANUAL;
    }

    return isCashPayOnly ? NONE : undefined;
  },
);
